<script>
  import { onMount } from 'svelte';

  import { APIS, INDEX_PARAMS } from '$lib/utils/consts';
  import { Request, successResp, errorResp } from '$lib/utils/_api';
  import { formatDate } from '$lib/utils/date-format';

  import angleImg from '$lib/assets/images/news.jpg';

  let angleList = [];

  onMount(async () => {
    try {
      const resp = await Request.get(APIS.angle, { params: INDEX_PARAMS });

      successResp(resp, (data) => {
        // console.log(data);
        angleList = data.list || [];
      });
    } catch(err) {
      console.log(err);
    }
  });

  // const angleList = [{
  //   id: 'aaaaa',
  //   title: '白溪怡和6号私募证券投资基金启动公告白溪怡和6号私募证券投资基金启动公告白溪怡和6号私募证券投资基金启动公告白溪怡和6号私募证券投资基金启动公告白溪怡和6号私募证券投资基金启动公告白溪怡和6号私募证券投资基金启动公告白溪怡和6号私募证券投资基金启动公告',
  //   date: '2022-02-08',
  // }, {
  //   id: 'aaaaa',
  //   title: '白溪怡和6号私募证券投资基金启动公告',
  //   date: '2022-02-08',
  // }, {
  //   id: 'aaaaa',
  //   title: '白溪怡和6号私募证券投资基金启动公告',
  //   date: '2022-02-08',
  // }, {
  //   id: 'aaaaa',
  //   title: '白溪怡和6号私募证券投资基金启动公告',
  //   date: '2022-02-08',
  // }, {
  //   id: 'aaaaa',
  //   title: '白溪怡和6号私募证券投资基金启动公告',
  //   date: '2022-02-08',
  // }];
</script>

<div class="flex gap-12 my-12">
  <div class="flex-auto">
    <h2 class="text-2xl font-medium text-orange-500 mb-6">白溪视角</h2>
    <ul class="leading-8">
      {#each angleList as angle}
        <li class="py-1">
          <span class="text-gray-400 mr-5">{angle.publishAt ? formatDate(angle.publishAt) : formatDate(angle.updatedAt)}</span>
<!--           <a class="hover:text-orange-500" href={`/detail/${notice.id}`}>{notice.title}</a> -->
          <a href="/detail/angle/{angle.newsId}" class="hover:text-orange-500">{angle.title}</a>
        </li>
      {/each}
      <li class="py-2">
        <a class="text-orange-500 hover:text-orange-400" href="/research/angle">更多……</a>
      </li>
    </ul>
  </div>
  <div class="shrink-0 hidden md:inline-block">
    <img src={angleImg} class="w-80 lg:w-96" alt="" />
  </div>
</div>
